export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_USER_FAIL = "LOGIN_USER_FAIL"

export const SOCIAL_LOGIN_REQUEST = "SOCIAL_LOGIN_REQUEST"
export const SOCIAL_LOGIN_SUCCESS = "SOCIAL_LOGIN_SUCCESS"
export const SOCIAL_LOGIN_FAIL = "SOCIAL_LOGIN_FAIL"

export const LOGIN_OTP = "LOGIN_OTP"

export const GET_CURRENT_USER = "GET_CURRENT_USER"
export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS"
export const GET_CURRENT_USER_FAIL = "GET_CURRENT_USER_FAIL"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const SOCIAL_LOGIN = "SOCIAL_LOGIN"

export const GET_LANGUAGES = "GET_LANGUAGES"
export const GET_LANGUAGES_SUCCESS = "GET_LANGUAGES_SUCCESS"
export const GET_LANGUAGES_FAIL = "GET_LANGUAGES_FAIL"

export const GET_ACCES_TOKEN_INFO = "GET_ACCES_TOKEN_INFO"
export const GET_ACCES_INFO_SUCCESSFULL = "GET_ACCES_INFO_SUCCESSFULL"
export const GET_ACCES_INFO_FAILED = "GET_ACCES_INFO_FAILED"

export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL"

export const EDIT_PROFILE = "EDIT_PROFILE"
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS"
export const EDIT_PROFILE_FAIL = "EDIT_PROFILE_FAIL"

export const SET_PASSWORD = "SET_PASSWORD"
export const SET_PASSWORD_SUCCESS = "SET_PASSWORD_SUCCESS"
export const SET_PASSWORD_FAIL = "SET_PASSWORD_FAIL"
